import ArrowLeft from "@svg/new-design/arrow-left";
import { toFarsiNumber } from "@utils/digits";
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button/types";
import { FC } from "react";
import { Button } from "@shared/components/button";

interface Props {
  watchPercent: number;
  boughtLabel: string;
  hasCertificate?: boolean;
}
const BoughtFooterCard: FC<Props> = ({
  watchPercent,
  boughtLabel,
  hasCertificate = false,
}) => {
  return (
    <div className="flex flex-col w-full items-end justify-end h-10 ">
      <div className="w-full grow shrink-0 bg-fds-secondary rounded-2   max-h-1 mb-1 ">
        <div
          className="bg-fds-brand h-1 rounded-full"
          style={{ width: `${watchPercent}%` }}
        />
      </div>
      <div className="flex justify-between items-center h-6  w-full">
        <p className="body-xsm text-fds-tertiary">
          {watchPercent !== 0 && `${toFarsiNumber(watchPercent)}٪ تکمیل شده  `}
        </p>
        {(watchPercent !== 100 || hasCertificate) && (
          <Button
            variant={BUTTON_VARIANT.TEXT}
            color={BUTTON_COLOR.PRIMARY}
            endIcon={
              watchPercent === 100 && !hasCertificate ? null : (
                <ArrowLeft className="h-5 w-5 " />
              )
            }
            size={BUTTON_SIZE.SMALL}
          >
            {boughtLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default BoughtFooterCard;
